/**
 * @param a date
 * @param b date
 */
export default function customSortDates(a: Date, b: Date) {
  return +!a - +!b || (a > b ? 1 : -1);
}
